import { Fragment } from "react";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import type { ITemplate } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";

import { TemplateContent } from "../../../../components";

export const Erc998Template = () => {
  const { data, isLoading } = useFetchData<ITemplate>("/erc998/templates");

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc998", "erc998.template"]} data={[{}, {}, data]} />

      <PageHeader message="pages.erc998.template.title" data={data} />

      <TemplateContent template={data} />
    </Fragment>
  );
};
